var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",class:['HomeSlides', { tinitial: _vm.first }, _vm.transition]},[(_vm.slide)?_c('HomeSlide',{attrs:{"slide":_vm.slide}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }